import Button from '../Button'
import BinIcon from '../../../assets/bin.svg'

/** @typedef {import('./TableActions.types').TableActionButtonProps} TableActionButtonProps */

/** @param {Omit<TableActionButtonProps, 'children'> & {alt?: string}} props */
export const DeleteTableActionButton = ({ title = 'Delete', alt = 'delete', ...props }) => (
  <TableActionButton title={title} {...props}>
    <img src={BinIcon} alt={alt} />
  </TableActionButton>
)

/** @param {TableActionButtonProps} props */
export const TableActionButton = ({ onClick, ...props }) => (
  <Button
    type='ghost'
    onClick={(e) => {
      // Prevent row click triggering.
      e.stopPropagation()
      onClick()
    }}
    {...props}
  />
)

/** @param {import('./TableActions.types').TableActionsProps} props */
export const TableActions = ({ children }) => {
  // TODO: Scope styles to module
  return <div className='table-actions'>{children}</div>
}
